import React from "react";
import { CheckCircle2 } from "lucide-react";

export const SectionDispatchBadge = ({ sectionId, status, compact = false, testIdSuffix = "" }) => {
  const record = status?.[sectionId];
  if (!record?.dispatched_at) return null;
  const timestamp = new Date(record.dispatched_at).toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
  return (
    <span className={`inline-flex items-center gap-1 rounded border border-emerald-200 bg-emerald-50 font-medium text-emerald-700 ${compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]"}`} data-testid={`section-dispatched-badge-${sectionId}${testIdSuffix ? `-${testIdSuffix}` : ""}`}>
      <CheckCircle2 className="h-3 w-3 shrink-0" />
      <span>Dispatched to Shop Floor ({timestamp})</span>
    </span>
  );
};